"use strict";

exports.__esModule = true;
exports.textMeshProToHtml = exports.htmlToTextMeshPro = void 0;
var _react = _interopRequireDefault(require("react"));
var _slateHtmlSerializer = _interopRequireDefault(require("slate-html-serializer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Refactor block tags into a dictionary for cleanliness.

const BLOCK_TAGS = {
  p: 'paragraph',
  ul: 'bulleted-list',
  li: 'list-item'
};

// Add a dictionary of mark tags.

const MARK_TAGS = {
  i: 'italic',
  b: 'bold'
};
const rules = [
// Rules to handle blocks
{
  deserialize(el, next) {
    const type = BLOCK_TAGS[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: 'block',
        type: type,
        data: {
          className: el.getAttribute('class')
        },
        nodes: next(el.childNodes)
      };
    }
  }
}, {
  serialize(obj, children) {
    if (obj.object === 'block') {
      switch (obj.type) {
        case 'paragraph':
          return /*#__PURE__*/_react.default.createElement("p", null, children);
        case 'bulleted-list':
          return /*#__PURE__*/_react.default.createElement("ul", null, children);
        case 'list-item':
          return /*#__PURE__*/_react.default.createElement("indent", null, children);
      }
    }
  }
},
// Rules to handle marks
{
  deserialize(el, next) {
    const type = MARK_TAGS[el.tagName.toLowerCase()];
    if (type) {
      return {
        object: 'mark',
        type: type,
        nodes: next(el.childNodes)
      };
    }
  },
  serialize(obj, children) {
    if (obj.object === 'mark') {
      switch (obj.type) {
        case 'bold':
          return /*#__PURE__*/_react.default.createElement("b", null, children);
        case 'italic':
          return /*#__PURE__*/_react.default.createElement("i", null, children);
      }
    }
  }
}];
const html = new _slateHtmlSerializer.default({
  rules
});
const htmlToTextMeshPro = node => {
  let TmpSerializedString = html.serialize(node);
  TmpSerializedString = TmpSerializedString.replace(/<indent>/g, '•<indent=20>');
  TmpSerializedString = TmpSerializedString.replace(/<p>/g, '');
  TmpSerializedString = TmpSerializedString.replace(/<\/p>/g, '');
  TmpSerializedString = TmpSerializedString.replace(/<ul>/g, '');
  TmpSerializedString = TmpSerializedString.replace(/<\/ul>/g, '');
  return TmpSerializedString;
};
exports.htmlToTextMeshPro = htmlToTextMeshPro;
const textMeshProToHtml = node => {
  const plainString = "<b>asdf</b>";
  let HtmlSerializedString = html.deserialize(plainString, [{
    toJSON: true
  }]);
  return HtmlSerializedString;
};
exports.textMeshProToHtml = textMeshProToHtml;